<template>
  <div class="faq-wrapper">
    <div class="questions-wrapper section">
      <div class="section__inner">
        <container>
          <div class>
            <div class="subpage-header__title section__title">
              <span class="color-light-green">Sıkça Sorulan</span> Sorular
            </div>
          </div>

          <div class="hero-search">
            <div class="hero-search__left">
              <input
                type="text"
                placeholder="Size nasıl yardımcı olabiliriz?"
                @focusin="focus(true)"
                @focusout="focus(false)"
              />
            </div>
            <button
              :class="{ 'addFocusedButton': hasfocus }"
              class="button hero-search__submit green"
            >
              <span class="button__wrp">
                <span class="button__icon">
                  <svg viewBox="0 0 20 20" class="icon">
                    <use xlink:href="/icon/icons.svg#icon-search" />
                  </svg>
                </span>
                <span class="button__txt">ŞEHİR ARA</span>
              </span>
            </button>
          </div>

          <div class="subpage-accordion text-left" v-for="(faq, $faqIndex) in faqs" :key="faq.id">
            <div class="subpage-accordion__title color-light-green">
              <p class="subpage-accordion__title-text">{{ faq.title }}</p>
            </div>
            <div class="subpage-accordion__wrapper">
              <div
                class="subpage-accordion__item"
                :class="{ active : $index === currentAccordion && $faqIndex === currentSection }"
                v-for="(faq, $index) in faq.accordions"
                :key="faq.id"
              >
                <div class="subpage-accordion__header" @click="toggle($faqIndex, $index)">
                  <div
                    class="subpage-accordion__title subpage-accordion__title--right"
                  >{{ faq.title }}</div>
                  <span class="subpage-accordion__caret">
                    <svg-icon type="icon-arrow-down" />
                  </span>
                </div>
                <slide-up-down
                  :duration="600"
                  :active="$index === currentAccordion && $faqIndex === currentSection"
                >
                  <div class="subpage-accordion__cnt" v-html="faq.text"></div>
                </slide-up-down>
              </div>
            </div>
          </div>
        </container>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Faq",
  metaInfo() {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: "Sıkça Sorulan Sorular",
      link: [
        { rel: "canonical" },
        { href: window.location.origin + "/sik-sorulan-sorular/" }
      ]
    };
  },
  data() {
    return {
      currentAccordion: null,
      currentSection: null,
      hasfocus: false,
      faqs: [
        {
          id: 0,
          title: "Öğrenci",
          accordions: [
            {
              id: 0,
              title: "Yurt seçerken öncelikle nelere dikkat etmeliyim?",
              text:
                "<p> Dikkat edilmesi gereken ilk özellik 	&quot;yurdun fiyatı	&quot;dır. " +
                "Ancak uygun bir yurt ararken yine de temel ihtiyaçlarınızı göz ardı etmemenizde fayda var. " +
                "Bunlar nelerdir? <br><br> " +
                "İlk olarak karar vermeniz gereken yurtta mı kalmalıyım apartta mı?" +
                " Bulunduğum bölgede hangisi daha avantajlı? </p>",
              active: false
            },
            {
              id: 1,
              title: "Yurt / apart okula yakın mı? Ulaşım nasıl sağlanıyor?",
              text:
                "<p> Yurtlarburada.com üzerinden incelemek istediğiniz yurdun detay sayfasına giderek konum bilgisini görüntüleyebilir " +
                "veya detaylı bilgi almak için yurt ile iletişime geçebilirsiniz. " +
                "teknisyeni ve 1 psikolog görev yapmaktadır. Ayrıca; A sınıfı Aile Hekimliği " +
                "Servis hizmetleri bilgisi için detay sayfası üzerinden özellikler bölümünü görüntüleyebilirsiniz. </p>",
              active: false
            },
            {
              id: 2,
              title: "Yurtta toplam kaç öğrenci kalıyor? ",
              text:
                "<p> Yurt detay sayfasında yurdun fotoğraflarının altında azami öğrenci sayısını görebilirsiniz. </p> ",
              active: false
            },
            {
              id: 3,
              title:
                "Odalar kaç kişilik? Tuvalet, banyo ve diğer ortak alanları kaç kişiyle paylaşıyorum?",
              text:
                "<p> Oda sayıları yurtlara göre değişmektedir. 1 kişilik odalardan 6 kişilik odalara kadar çeşitli oda tipleri bulunmaktadır. " +
                "Tuvalet ve banyo bazı yurtlarda odalarda, bazı yurtlarda ise ortak alanlarda bulunmaktadır. </p>",
              active: false
            },
            {
              id: 4,
              title:
                "Odanın konumu nasıl? Oda gün içerisinde ne kadar ışık alıyor? Havalandırma sistemi ve pencere sayısı yeterli mi?",
              text:
                "<p> Sitemize kayıtlı tüm yurtlar MEB’e bağlı olup denetlemeye tabi tutuldukları için MEB standartlarına uygun olmak zorundadırlar. " +
                "Bu sebeple binanın cephesi farklılık gösterebilse de havalandırma ve pencere olarak yurtlar yeterli donanıma sahiptir. </p>",
              active: false
            },
            {
              id: 5,
              title:
                "Yurt / apart ne kadar güvenli? Güvenlik görevlisi, güvenlik kamerası, alarm sistemleri mevcut mu?",
              text:
                "<p> Bazı yurt / apartların tamamında bulunmasa da büyük çoğunluğunda güvenlik önlemleri alınmaktadır ve zorunludur. " +
                "Güvenlik önleminden en az biri birçoğunda mevcut. Yurtlarda güvenlik görevlisi olmasa bile mutlaka gece görevlileri bulundurulmak zorundadır. </p>",
              active: false
            },
            {
              id: 6,
              title:
                "Yurtta yemek veriliyor mu, veriliyor ise günde kaç öğün? Yemek fiyata dâhil mi yada öğrencilerin yemek hazırlayabileceği ortak / kişiye özel mutfak var mı?",
              text:
                "<p> Yurtların büyük çoğunluğunda mutfak bulunmaktadır. Sabah kahvaltısı ve akşam yemeği şeklinde iki öğün yemek sunulur. " +
                "Ücrete dahil olup olmaması yurttan yurda veya yurt ile anlaşmanıza göre değişiyor. " +
                "Apart ve pansiyonlarda ise öğrenci kendisi mutfakta yemeğini hazırlamak durumunda kalıyor. </p>",
              active: false
            },
            {
              id: 7,
              title:
                "Yurt giriş / çıkış saatleri nelerdir? Giriş çıkışlar kartlı sistemle ya da parmak okuyucuyla takip ediliyor mu?",
              text:
                "<p> Yurtların giriş / çıkış saatleri bulunduğu il ve bölge ile yurdun yetkilisine ve yurt kurallarına göre değişiklik gösterebiliyor. " +
                "Kartlı sistem ya da parmak okuyucu özellikle büyük şehirlerdeki yurtlarda daha fazla yaygınlaşmış durumda. " +
                "Bununla birlikte bazı yurtlar &quot;öğrenci takip sistemi&quot; programını kullanıyor. " +
                "Bu program velinin öğrenciyi takibini kolaylaştırıyor. </p>",
              active: false
            },
            {
              id: 8,
              title:
                "Sosyal aktivite alanları nelerdir? Yurt içerisinde vakit nasıl değerlendirilir?",
              text:
                "<p> Yurtların kendi etkinlikleri (mangal günleri, piknik günleri, yılbaşı ve mezuniyet organizasyonları gibi ) " +
                "haricinde oyun salonları, spor salonları, havuz, hobi odası gibi bölümleri bulunmakta ve bir " +
                "barınma alanı haricinde yurtta arkadaşlarınızla keyifli vakit geçirmenize olanak sağlamaktadır. </p>",
              active: false
            },
            {
              id: 9,
              title:
                "Yurdun reviri ya da anlaşmalı olduğu bir sağlık kurumu var mı?",
              text:
                "<p> Yurt kapasitesine bağlı olarak MEB yönetmeliğine göre revir bulundurma zorunluluğu vardır. " +
                "Bazı yurtların ise sağlık kurumları ile anlaşmaları bulunuyor ve ücretsiz şekilde tedavi ya da muayene olabiliyorsunuz. </p>",
              active: false
            },
            {
              id: 10,
              title:
                "Ütü, çamaşır, temizlik hizmetleri yurt tarafından mı sağlanıyor?",
              text:
                "<p> Yurtların çoğunda ütü ve çamaşır odası bulunuyor. Bazıları ücretsiz bazıları çok cüzi miktarda ücretlidir. " +
                "Temizlik hizmeti ise yurtların genelinde günlük ya da haftalık olarak temizlik görevlileri tarafından yapılıyor. </p>",
              active: false
            },
            {
              id: 11,
              title: "Isınma ve sıcak su imkânı var mı?",
              text:
                "<p> Isınma için yurtların çoğunda merkezi sistem kullanılmaktadır. " +
                "Pansiyon ve apartlarda ise kombi üzerinden kendiniz ayarlama yapabiliyorsunuz. " +
                "Bazı yurtlarda sıcak su 7/24 bulunmuyor. Bu durumda yurt tarafından belirtilen saat aralıklarına dikkat etmeniz gerekiyor. </p>",
              active: false
            },
            {
              id: 12,
              title: "Kablosuz internet hizmeti mevcut mu?",
              text:
                "<p> Kablosuz internet neredeyse yurtların tamamında mevcut. " +
                "Ancak hızlı bir internet arayışında olan öğrenciler unutmasın ki " +
                "yurtlardaki kişi sayısı pek de az değil. Zaman zaman bu konuda sorun yaşayabilirsiniz. </p>",
              active: false
            },
            {
              id: 13,
              title:
                "Oda haricinde ders çalışabileceğim alan (etüt salonu) mevcut mu? Var ise yeterli donanıma sahip mi?",
              text:
                "<p> Etüt salonları büyük küçük çoğu yurtta mevcut. " +
                "Bazı yurtlarda buna ek olarak araştırma ve ödev yapabileceğiniz bilgisayar odaları da bulunmaktadır.	</p>",
              active: false
            },
            {
              id: 14,
              title:
                "Üniversiteme en yakın mesafedeki yurtlara sitenizden nasıl ulaşabilirim?",
              text:
                "<p> Yurtlarburada.com anasayfası üzerinden şehir, üniversite ve yurt tipi seçerek aramalarınızı kendinize uygun şekilde filtreleyebilirsiniz. " +
                "Yönlendirilmiş olduğunuz sayfada &quot;fakülte&quot; seçimi yaparak aramayı kampüsünüze kadar daraltabilir ve " +
                "üniversitenizin seçmiş olduğunuz kampüsüne en yakın yurtları sayfa üzerinden incelemeye başlayabilirsiniz.	</p>",
              active: false
            },
            {
              id: 15,
              title:
                "Üniversiteyi kazandığım şehirdeki yurtlara sitenizden nasıl ulaşabilirim?",
              text:
                "<p> yurtlarburada.com anasayfası üzerinde bulunan üst menüden &quot;şehirler&quot;e tıklayarak veya anasayfa üzerinde bulunan " +
                "arama çubuğundan sadece şehir seçimi yapıp &quot;Yurt Ara&quot; butonuna tıklayarak seçmiş olduğunuz " +
                "şehirde bulunan yurt, apart ve pansiyonları görüntüleyebilirsiniz.	</p>",
              active: false
            },
            {
              id: 16,
              title:
                "Sitenizden kendi bütçeme ve ihtiyaçlarıma en uygun yurda nasıl ulaşabilirim?",
              text:
                "<p> yurtlarburada.com anasayfası üzerinden şehir, üniversite ve yurt tipi seçimi yapıp açılan sayfada fakültenizi " +
                "seçtikten sonra &quot;Yurt Fiyatlarını Öğren&quot; butonuna tıklayıp formu doldurarak seçmiş olduğunuz filtredeki " +
                "yurtlara  sizin adınıza tarafımızdan ücretsiz mesaj gönderilmektedir. Bu sayede yurtlar " +
                "size geri dönüş sağlıyor aradığınız kriterlerdeki yurda en hızlı şekilde ulaşabilirsiniz. </p>",
              active: false
            },
            {
              id: 17,
              title: "Yurt ücretlerini nasıl öğrenebilirim?",
              text:
                "<p> Beğendiğiniz yurdun &quot;İncele&quot; butonuna tıklayarak detaylı bilgilerine ulaşabilirsiniz. " +
                "Yurt detay sayfası üzerinde dilerseniz hiçbir ücret ödemeden formu doldurup yurdun sizi aramasını isteyebilirsiniz. " +
                " Ya da &quot;Yurdu Ara&quot; butonu üzerinden yurtla kendiniz arayarak iletişim kurabilir ve ya " +
                "  &quot;Whatsapp&quot; ikonuna tıklayarak whatsapp üzerinden yurtla iletişime geçebilirsiniz. </p>",
              active: false
            }
          ]
        },
        {
          id: 1,
          title: "Yurt Sahipleri",
          accordions: [
            {
              id: 0,
              title:
                "Yurdumu sitenizde etkileyici bir şekilde nasıl tanıtabilirim?",
              text:
                "<p> Yurtlarburada.com arama motorlarında ön sırada yaralan sektörün lideri bir yurt arama portalıdır. " +
                "Yurtlar ile öğrenciler arasında bir köprü görevi görmektedir. " +
                "Dolayısı ile sitemiz içerisinde yer aldığınızda sürekli güncellenen bilgileriniz, " +
                "içerik ve fotoğraflarınız ile hedef kitlenize kendinizi daha iyi tanıtabilirsiniz. " +
                "Ayrıca yurtlarburada.com ile iletişim bilgileriniz ve ulaşım bilgilerinizin doğru " +
                "bir şekilde sürekli güncellendiğinden öğrencilerin daha hızlı bir şekilde size ulaşması sağlanmaktadır. </p>",
              active: false
            },
            {
              id: 1,
              title:
                "Neden ilan vermeliyim? İlan verdikten sonra yurduma katkısı nedir?",
              text:
                "<p> Yurtlarburada.com 2007 yılında Türkiye’de kurulan ilk yurt arama portalıdır. " +
                "Arama motorlarında ön sırada yer alan ve sektörün lideri konumundaki yurtlarburada.com " +
                "Bilişim derneği ve birçok üniversite tarafından ödül alan bir portaldır. " +
                "Devlet televizyonu olan TRT’de ve birçok ulusal basında haberlerde yer " +
                "alarak öğrencilere referans olarak gösterilmektedir. <br><br> " +
                "Yurtlarburada.com olarak Türkiye genelinde tüm arama motorlarında ön sırada yer alarak kız ve erkek " +
                "yurtları aramalarında yurtlar ile öğrenciler arasında bir köprü görevi görmekteyiz. " +
                "İletişim araçlarını etkili bir şekilde kullanan hedef kitleniz öğrenciler, " +
                "sitemizi çok iyi tanımakta ve yurtlara yurtlarburada.com üzerinden ulaşmaktadır. " +
                "Sitemizde şuanda aktif olarak 700 adet yurt ilanı bulunmaktadır. Ve bu sayı her geçen gün artmaktadır. " +
                "Sitemizin modern tasarımı, kolay kullanımı ve yurtların öne çıkarmak istediği özelliklerini hedef kitleye " +
                "vermek istediği mesajı etkili bir şekilde anlatıyor ve tanıtıyor olmasından dolayı " +
                "hedef kitleniz öğrencilere daha hızlı ulaşılmasını sağlamaktadır. </p>",
              active: false
            },
            {
              id: 2,
              title: "Sitenizdeki ilan Süresi Ne kadardır?",
              text:
                "<p> Yurtlarburada.com‘da reklam sözleşmeleri hangi tarihte sitemize giriş yaparsanız yapın bulunduğunuz " +
                "sene itibariyle 1 mayıs tarihinde sonlanır. Yeni Sözleşmeler ve reklam yenilemeleri bu " +
                "tarihten itibaren yapılmaktadır. Sitemize bu tarihten sonra reklam vermek isteyen ya da " +
                "veren yurtların sözleşmeleri de yine bir sonraki yılın 1 Mayıs tarihi itibari ile son bulur. </p>",
              active: false
            },
            {
              id: 3,
              title:
                "Siteniz reklam ücretleri ve fiyatlandırmanıza nasıl ulaşabilirim?",
              text:
                "<p> Sitemizdeki reklam ücretlerine iletişim Formu kısmını doldurarak veya yurdumu ekle kısmını doldurarak mesaj atabilirsiniz. " +
                "Yine iletişim telefonlarımızdan sitemize kolayca ulaşabilir; yetkili " +
                "uzmanlarımız tarafından reklam alanları ve fiyatlandırma hakkında detaylı bilgi alabilirsiniz. </p>",
              active: false
            },
            {
              id: 4,
              title: "Öğrenciler siteniz üzerinden yurduma nasıl ulaşır?",
              text:
                "<p> Öğrenciler yurtlarburada.com’a giriş yaptığında size kolayca ulaşabileceği birçok yoldan " +
                "kendilerine en uygun olanı tercih edebilirler. Öğrencilerimiz üniversiteyi kazanmış olduğu " +
                "şehri seçerek arama yapabilmekte, ilgili şehirdeki yurtlar arasında size kolayca ulaşabilmektedir. " +
                "Şehirler bölümünde yer alan ilçeler kısmı ile bulunduğunuz ilçeden de size rahat bir şekilde ulaşabilirler. " +
                "Ayrıca üniversitede arama seçeneğimiz ile üniversitesini seçerek ilgili üniversite etrafında konumlanmış " +
                "olan yurtlar içinden size hızlı bir şekilde ulaşırlar. Reklam içeriğinizde yurt bilgileriniz, " +
                "fotoğraflarınız, özellikleriniz ve yurt telefonlarınız, whatsapp iletişim hattınız yer almaktadır. &quot;Yurda fiyat sor&quot; " +
                "kısmından mesaj atarak ya da telefonlarınızdan sizinle irtibata geçerek fiyat ve yurt hakkında öğrenmek istedikleri gerekli bilgileri almaktadırlar. </p>",
              active: false
            },
            {
              id: 5,
              title: "Sitenizdeki yurt arama seçenekleri nasıldır?",
              text:
                "<p> Sitemizde öğrencilerin aradığı kriterlere uygun yurdu bulmaları oldukça kolaydır. " +
                "Sitemizde &quot;şehre göre&quot;, &quot;üniversite seçimi yaparak&quot;, &quot;yurt tipi / kız –erkek seçimi yaparak&quot; ve &quot;ilçeye göre&quot; " +
                "arama özelikleri vardır. Yurtlarburada.com öğrencilerimizin her arama şeklini kullanarak yurdunuza kolayca ulaşabileceği şekilde tasarlanmıştır. </p>",
              active: false
            },
            {
              id: 6,
              title:
                "Sitenize üye giriş kaydı ile kendim de giriş yaparak bilgilerimde değişiklik yapabilir miyim?",
              text:
                "<p> Yurtlarburada.com’a kendi üye bilgileriniz ile giriş yaparak bilgilerinizi güncelleyebilir; " +
                "fotoğraflarınızı değiştirebilir, öğrencilerden gelen mesajları cevaplayabilirsiniz. </p>",
              active: false
            }
          ]
        }
      ]
    };
  },
  methods: {
    toggle(faqIndex, index) {
      if (index === this.currentAccordion) {
        this.currentAccordion = null;
        this.currentSection = null;
      } else {
        this.currentAccordion = index;
        this.currentSection = faqIndex;
      }
    },
    focus(value) {
      this.hasfocus = value;
    },
  }
};
</script>

<style lang="scss">
@import "../assets/scss/components/questions";
.addFocusedButton {
  background: #4b5ba4 !important;
  box-shadow: 0px 8px 29px 0px rgba(75, 91, 164, 0.42) !important;
}
</style>
